import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Hero.css";


const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 900,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  pauseOnHover: true,
};

const Hero = () => {
  const sliderRef = useRef(null);
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setBannerData(data.banners);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <section className="hero-section">
      <Slider ref={sliderRef} {...settings}>
        {bannerData.map((slide) => (
          <div key={slide.id}>
            <div
              className="hero-slide"
              style={{
                backgroundImage: `url(${process.env.REACT_APP_IMAGE_BASE_URL}/${slide.folder_path}/${slide.image})`,
              }}
            >
              <div className="hero-overlay"></div>
              <div className="hero-container container">
                <div className="hero-content">
                  <h1>{slide.heading}</h1>
                  <p className="hero-desc">{slide.sub_heading}</p>
                  <div className="hero-actions">
                    <a href={slide.button_1_link} className="btn-hero-primary">
                      {slide.button_1_name}
                    </a>
                    <a href={slide.button_2_link} className="btn-hero-secondary">
                      {slide.button_2_name}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Custom Arrows */}

      <div className="hero-arrows">
        <button
          className="hero-arrow"
          onClick={() => sliderRef.current.slickPrev()}
        >
          <i className="bi bi-arrow-left"></i>
        </button>

        <button
          className="hero-arrow"
          onClick={() => sliderRef.current.slickNext()}
        >
          <i className="bi bi-arrow-right"></i>
        </button>
      </div>
    </section>
  );
};

export default Hero;